import classnames from 'classnames';
import css from './RateStar.module.scss';
import { useMemo, useRef } from 'react';

const RateStar = ({ size, attribute, item, isReadOnly, hover, setHover, setVal, setFormData, title }) => {
    const inactiveColor = 'var(--greyInactiveStars)';
    const activeColor = 'var(--goldColor)';

    const hoverCalc = useMemo(() => {
        if (item - hover === 0.5) {
            return 'half';
        }
        return item <= hover;
    }, [hover, item]);

    const allStar = useRef();
    const calcValue = (e) => {
        if (e.target === allStar.current) {
            return item;
        } else {
            return item - 0.5;
        }
    };
    const onHoverFunc = (e) => {
        if (!isReadOnly) {
            setHover(calcValue(e));
        }
    };
    const selectFunction = (e) => {
        if (!isReadOnly) {
            setHover(calcValue(e));
            setVal(calcValue(e));
            setFormData(attribute, calcValue(e));
        }
    };
    return (
        <div
            style={{ padding: `0 ${size / 3 / 2}px`, cursor: isReadOnly ? 'default' : 'pointer' }}
            className={classnames(css.ratingItem)}
            onClick={selectFunction}
            onMouseEnter={onHoverFunc}
            onMouseMove={onHoverFunc}
        >
            <div ref={allStar} className={css.ratingHalf}></div>
            <div className={css.ratingStar}>
                <svg width={size} height={size} viewBox='0 0 36 34'>
                    <path
                        d='M16.6393 0.415572C17.0418 0.143819 17.5163 0 18 0C18.4837 0 18.9582 0.143819 19.3607 0.415572C19.7609 0.685772 20.0724 1.07094 20.2501 1.52361L23.8386 10.3648C23.8569 10.411 23.8898 10.4551 23.9373 10.4894C23.9845 10.5235 24.0432 10.5456 24.1069 10.5505L24.1091 10.5506L33.7229 11.161C35.9305 11.3012 36.8135 14.0885 35.0984 15.4851L27.7367 21.4797L27.7349 21.4811C27.6839 21.5238 27.6493 21.5767 27.6312 21.632C27.613 21.6877 27.6113 21.7464 27.6261 21.8025L27.6268 21.8053L30.0003 30.94C30.5521 33.0636 28.2424 34.7844 26.3772 33.6283L18.1621 28.5362L18.1602 28.5351C18.1602 28.5351 18.0587 28.49 18 28.49C17.9413 28.49 17.8856 28.5065 17.8398 28.5351L17.8379 28.5362L10.2036 33.2683C8.12843 34.5546 5.55793 32.6402 6.17203 30.2767L8.3732 21.8053L8.37392 21.8025C8.38867 21.7464 8.38701 21.6877 8.36881 21.632C8.35074 21.5767 8.31608 21.5238 8.26502 21.4811L8.26327 21.4797L0.901592 15.4851C-0.813465 14.0885 0.0694981 11.3012 2.27714 11.161L11.8931 10.5505C11.9568 10.5456 12.0155 10.5235 12.0627 10.4894C12.1102 10.4551 12.1431 10.411 12.1614 10.3648L12.1645 10.357L15.7499 1.52362C15.9276 1.07093 16.2391 0.685771 16.6393 0.415572Z'
                        fill={`url(#paint_star_${item}_${attribute})`}
                        // fillOpacity='0.7'
                    />
                    <defs>
                        <linearGradient
                            id={`paint_star_${item}_${attribute}`}
                            x1='-4.05114e-07'
                            y1='13.5'
                            x2='36'
                            y2='13.5'
                            gradientUnits='userSpaceOnUse'
                        >
                            {/* Left */}
                            <stop stopColor={hoverCalc ? activeColor : inactiveColor} />
                            <stop offset='0.5' stopColor={hoverCalc ? activeColor : inactiveColor} />

                            {/* Right */}
                            <stop offset='0.5001' stopColor={hoverCalc && hoverCalc !== 'half' ? activeColor : inactiveColor} />
                            <stop offset='0.703125' stopColor={hoverCalc && hoverCalc !== 'half' ? activeColor : inactiveColor} />
                            <stop offset='1' stopColor={hoverCalc && hoverCalc !== 'half' ? activeColor : inactiveColor} />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            {title ? <div className={css.title}>{title}</div> : null}
        </div>
    );
};
export default RateStar;
